import { Outlet } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { isAdmin } from '@/lib/permissions';
import { Card } from '@/components/ui/Card';
import { PageHeader } from '@/components/ui/PageHeader';

export function AdminGuard() {
  const { user } = useAuth();
  if (!isAdmin(user)) {
    return (
      <>
        <PageHeader title="Zugriff verweigert" />
        <Card>
          <p>Für diesen Bereich benötigst du Admin-Rechte.</p>
        </Card>
      </>
    );
  }
  return <Outlet />;
}
